// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__32QCr","errorLogs":"EditorFooter_errorLogs__1jE4g"};